<template>
  <div ref="content" class="content">
    <!-- /home/static/ciyuankoudai/noten/image/pc660 -->
    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/22.png'"
      alt="编程"
      style="width: 1600px;height: auto;"
      fit="contain"
    ></el-image>
    <div style="width: 1600px;" class="mobile">
      <div class="outer">
        <div class="outer-content ">
          <div class=" column">
            <div class="title">一键获取授权资料及项目报价</div>
            <!--<div class="subtitle">已有&nbsp; {{ count }}次下载</div> -->
            <div class="info">
              <div class="item row">
                <div class="names" style="caret-color: transparent;">
                  称&nbsp;呼<span style="color: red;">&nbsp;*</span> :
                </div>
                <input
                  type="text"
                  class="input"
                  v-model="name"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div class="item row">
                <div class="names1" style="caret-color: transparent;">
                  电&nbsp;话<span style="color: red;">&nbsp;*</span> :
                </div>
                <input
                  type="tel"
                  class="input"
                  maxlength="11"
                  required
                  v-model="phone"
                  placeholder="请输入您的手机号"
                />
              </div>
            </div>
          </div>

          <div
            class="center"
            style="margin-top: 25px;caret-color: transparent;"
            @click="submit"
          >
            <div class="btn center-just">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/2@2x-8_04.png'"
      alt="编程"
      style="width: 1600px;height: auto;"
      fit="contain"
    ></el-image>

    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/2@2x-8_05.png'"
      alt="编程"
      style="width: 1600px;height: auto;"
      fit="contain"
    ></el-image>

    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/2@2x-8_06.png'"
      alt="编程"
      style="width: 1600px;height: auto;"
      fit="contain"
    ></el-image>

    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/2@2x-8_07.png'"
      alt="编程"
      style="width: 1600px;height: auto;"
      fit="contain"
    ></el-image>
    <!-- <Box1></Box1>
    <Box2 @custom-event="scrollToBottom"></Box2>
    <Box3></Box3>
    <Box4></Box4> -->
    <!-- <div style="height: 600px;"><Test></Test></div> -->
    <div style="width: 1600px;" class="mobile">
      <div class="outer">
        <div class="outer-content ">
          <div class=" column">
            <div class="title">一键获取授权资料及项目报价</div>
            <div class="subtitle">已有&nbsp; {{ count }}次下载</div>
            <div class="info">
              <div class="item row">
                <div class="names" style="caret-color: transparent;">
                  称&nbsp;呼<span style="color: red;">&nbsp;*</span> :
                </div>
                <input
                  type="text"
                  class="input"
                  v-model="name"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div class="item row">
                <div class="names1" style="caret-color: transparent;">
                  电&nbsp;话<span style="color: red;">&nbsp;*</span> :
                </div>
                <input
                  type="tel"
                  class="input"
                  maxlength="11"
                  required
                  v-model="phone"
                  placeholder="请输入您的手机号"
                />
              </div>
            </div>
          </div>

          <div
            class="center"
            style="margin-top: 25px;caret-color: transparent;"
            @click="submit"
          >
            <div class="btn center-just">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="staff">扫码添加次元口袋资料库</div>
    <div class="staff1">招商负责人&nbsp;&nbsp;张经理</div>

    <el-image
      :src="$domain + 'static/ciyuankoudai/noten/image/pc/2@2x-8_08-3.png'"
      alt="编程"
      style="width: 280px;height: auto;"
      fit="contain"
    ></el-image>
  </div>
</template>

<script>
import api from "@/api";
import { userPortList } from "@/api/port";
import Box1 from "@/views/home/boxList/box1.vue";
import Box2 from "@/views/home/boxList/box2.vue";
import Box3 from "@/views/home/boxList/box3.vue";
import Box4 from "@/views/home/boxList/box4.vue";
import Test from "@/components/test";
import axios from "axios";
export default {
  components: { Box1, Box2, Box3, Box4, Test },
  data() {
    return {
      active: 0,
      sidebarActive: 4,
      count: 2218,
      typeList: ["次元口袋编程", "口袋英语同步学", "口袋网校App", "编程视频课"],
      newCityData: "",
      province: "北京市",
      city: "北京市",
      name: "",
      phone: "",
      dialogVisible: false
    };
  },
  methods: {
    switchType(index) {
      this.active = index;
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    sidebar(index) {
      this.sidebarActive = index;
    },
    out() {
      this.sidebarActive = 4;
    },
    scrollToBottom() {
      const contentElement = this.$refs.content;
      contentElement.scrollIntoView({ behavior: "smooth", block: "end" });
    },
    isValidChinesePhoneNumber(number) {
      const mobileRegExp = /^1[3456789]\d{9}$/;
      const landlineRegExp = /^0\d{2,3}-?\d{7,8}$/;
      return mobileRegExp.test(this.phone) || landlineRegExp.test(this.phone);
    },
    async downloadFile(filename, name) {
      try {
        const response = await axios.get(filename, {
          responseType: "blob"
        });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let extend = filename.split("/").pop();

        if (extend) {
          let lastIndex = extend.lastIndexOf(".");
          const extension = extend.substring(lastIndex + 1);
          if (name) {
            link.download = name + "." + extension;
          } else {
            link.download = extend;
          }
          link.click();
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        // Handle error
      }
    },
    submit() {
      if (this.name) {
        if (this.isValidChinesePhoneNumber()) {
          let params = {
            name: this.name,
            mobile: this.phone,
            province: this.province,
            city: this.city,
            channel: "官网下载资料"
          };
          api
            .post(userPortList.postInfo, params)
            .then(res => {
              console.log(res.data);
              this.downloadFile(
                "https://static.smallschoolbag.com/static/ciyuankoudai/noten/image/pc/课程体系介绍.pdf",
                "次元口袋课程体系介绍"
              );
              this.count += 1;
              this.dialogVisible = true;
              this.name = "";
              this.phone = "";
              this.province = "北京市";
              this.city = "北京市";
            })
            .catch(error => {
              // 捕获异常并处理
              console.error("Error:", error);
            });
        } else {
          this.$message({
            message: "请输入正确的手机号，以便我们能够联系到您！",
            type: "error",
            duration: 5000
          });
        }
      } else {
        this.$message({
          message: "请输入您的称呼，方便之后与您沟通！",
          type: "warning",
          duration: 5000
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/_functions.scss";
.staff {
  font-size: 20px;
  font-weight: 500;
}
.staff1 {
  font-size: 19px;
  font-weight: 500;
  color: #c52222;
}
.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.outer {
  height: getHeight(300);
  width: getWidth(483);
  // background-color: antiquewhite;
  display: flex;
  justify-content: center;
  .outer-content {
    // background-color: red;
    // width: 80%;
    // height: 62%;
    // margin-top: 50px;
    // display: flex;
    // flex-wrap: wrap;
    .title {
      display: flex;
      align-self: center;
      color: #585656;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      // color: #1dc2ff;
      line-height: getHeight(37);
      // margin-top: getHeight(100);
      // margin-bottom: getHeight(20);
    }
    .subtitle {
      display: flex;
      justify-content: center;
      justify-items: center;
      color: #a7a1a1;
      font-size: 14px;
      margin-top: 10px;
    }
    .info {
      display: flex;
      flex-direction: row;
      margin-top: getHeight(10);
      .item {
        width: 300px;
        height: getHeight(60);
        background: #f5f7ff;
        border: 1px solid #b2c2ff;
        border-radius: get2Px(20);
        display: flex;
        align-items: center;
        justify-content: center;
        // margin-top: getHeight(20);
        margin-left: getWidth(20);

        // margin-left: getWidth(45);
        .selects {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-image: url("http://static.smallschoolbag.com/static/noten/website/home/index1_box6_dropdownbtn.png");
          background-repeat: no-repeat;
          background-position: center right;
          // padding-right: getWidth(10);
          height: getHeight(40);
          width: getWidth(600);
          border: none;
          outline: none;
          background-color: #f5f7ff;
          font-size: 14px;
          color: #1966ff;
          cursor: pointer;
        }
        .names {
          width: 60px;
          line-height: getHeight(37);
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1966ff;
        }
        .names1 {
          width: 60px;
          line-height: 37px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1966ff;
        }
        .input {
          width: getWidth(360);
          height: getHeight(50);
          border: none !important;
          outline-color: invert;
          outline-style: none;
          outline-width: 0px;
          border: none;
          border-style: none;
          text-shadow: none;
          -webkit-appearance: none;
          -webkit-user-select: text;
          outline-color: transparent;
          box-shadow: none;
          background: #f5f7ff;
          // font-weight: bold;
          color: #1a1a1a;
          font-size: 14px;
        }
        ::-webkit-input-placeholder {
          color: rgb(190, 187, 187);
        }
      }
    }
    .btn {
      // background-image: url(http://static.smallschoolbag.com/static/noten/website/home/index1_box6_btn.png);
      // background-size: 100% 100%;
      background-color: #3675f1;
      width: getWidth(400);
      height: getHeight(60);
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      letter-spacing: 1px;
      color: #ffffff;
      line-height: getHeight(37);
      cursor: pointer;
      border-radius: 10px;
      // margin-top: 20px;
    }
  }
}

.sidebar-active {
}
.bar {
  height: 1px;
  background-color: rgb(220, 226, 226);
  width: 80%;
}
.center-just {
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 15px 15px 0px rgba(225, 226, 230, 0.3);
  position: sticky;
  top: 0;
  z-index: 10001;
  .item {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    cursor: pointer;
    .active-image {
      width: 20px;
      height: 8px;
      align-self: center;
      margin-top: 7px;
    }
  }
  .active {
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1a1a1a;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue